<div class="PriceContainer Flexbox Gap--Tiny Align--center" [class.RoundedOnly]="typeToShow() === 'rounded-only'" [class.Nowrap]="nowrap() || displayStyle() === 'compact'" [class.Compact]="displayStyle() === 'compact'">
  <span class="Price"><b>
    @if (priceToShow()) {
      {{ priceToShow() | currency: 'USD' : 'symbol' : '1.0-0' }}
    } @else {
      No Price
    }
  </b></span>
  @if (typeToShow()) {
    @if (typeToShow() !== '(rounded-only)' && typeToShow() !== '(retailer)') {
      <span class="PriceType"> {{ typeToShow() }}</span>
    }
  }
</div>
